import { connect } from 'react-redux';
import {
  fetchServiceKey,
  deleteServiceKey,
  setServiceKeyForm,
} from '../../../store/modules/servicekey';

import ServiceKey from '../components/ServiceKey';

const mapActionCreators = {
  fetchServiceKey,
  deleteServiceKey,
  setServiceKeyForm,
};

const mapStateToProps = state => ({
  serviceKey: state.serviceKey.serviceKeys[state.serviceKey.current],
  serviceKeys: state.serviceKey.serviceKeys,
  fetching: state.serviceKey.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(ServiceKey);



// WEBPACK FOOTER //
// ./src/routes/ServiceKey/containers/ServiceKeyContainer.js